import React, { type ReactElement } from 'react';

import { useInvertedLocalize } from '../../hooks';

import './SkipToMainContentLink.css';

/**
 * First focusable control in the AAG shell; moves focus to `#aag-main-content`.
 */
function SkipToMainContentLink(): ReactElement {
  const l = useInvertedLocalize();

  return (
    <a href='#aag-main-content' className='SkipToMainContentLink'>
      {l('Skip to main content')}
    </a>
  );
}

export default SkipToMainContentLink;
